// Links list — Session C migration to the FwTable pattern.
// Same request shape as the AgTable page it replaces; columns from
// agModule.json; permission gates unchanged.
import ModuleListPage from "elements/Table/ModuleListPage";

export default function List() {
  return (
    <ModuleListPage
      module="link"
      title="Links"
      api="admin/link"
      url="link"
      columnsKey="link"
      quickKey="name"
      quickPlaceholder="Filter by name…"
      perms={["lkr", "lkc", "lku", "lkd"]}
    />
  );
}
